export default __webpack_public_path__ + "static/media/saint_aubin2.cfd71e06.jpg";